import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { DateTime } from 'luxon';
import { environment } from 'src/environments/environment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', { providedIn: 'root', factory: () => environment.remoteServiceBaseUrl });


export class CountryIpResultDto implements ICountryIpResultDto {
  ip!: string | undefined;
  shortName!: string | undefined;
  name!: string | undefined;
  id!: number;

  constructor(data?: ICountryIpResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ip = _data["ip"];
      this.shortName = _data["shortName"];
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CountryIpResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new CountryIpResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ip"] = this.ip;
    data["shortName"] = this.shortName;
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface ICountryIpResultDto {
  ip: string | undefined;
  shortName: string | undefined;
  name: string | undefined;
  id: number;
}

export class CountryOutputDto implements ICountryOutputDto {
  shortName!: string | undefined;
  name!: string | undefined;
  id!: number;

  constructor(data?: ICountryOutputDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.shortName = _data["shortName"];
      this.name = _data["name"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CountryOutputDto {
    data = typeof data === 'object' ? data : {};
    let result = new CountryOutputDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["shortName"] = this.shortName;
    data["name"] = this.name;
    data["id"] = this.id;
    return data;
  }
}

export interface ICountryOutputDto {
  shortName: string | undefined;
  name: string | undefined;
  id: number;
}

export class ListResultDtoOfCountryOutputDto implements IListResultDtoOfCountryOutputDto {
  items!: CountryOutputDto[] | undefined;

  constructor(data?: IListResultDtoOfCountryOutputDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(CountryOutputDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfCountryOutputDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfCountryOutputDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfCountryOutputDto {
  items: CountryOutputDto[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
  version!: string | undefined;
  features!: { [key: string]: boolean; } | undefined;
  medNetUrl!: string | undefined;
  stripePublishableKey!: string | undefined;

  constructor(data?: IApplicationInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"];
      if (_data["features"]) {
        this.features = {} as any;
        for (let key in _data["features"]) {
          if (_data["features"].hasOwnProperty(key))
            (<any>this.features)![key] = _data["features"][key];
        }
      }
      this.medNetUrl = _data["medNetUrl"];
      this.stripePublishableKey = _data["stripePublishableKey"];
    }
  }

  static fromJS(data: any): ApplicationInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["version"] = this.version;
    if (this.features) {
      data["features"] = {};
      for (let key in this.features) {
        if (this.features.hasOwnProperty(key))
          (<any>data["features"])[key] = (<any>this.features)[key];
      }
    }
    data["medNetUrl"] = this.medNetUrl;
    data["stripePublishableKey"] = this.stripePublishableKey;
    return data;
  }
}

export interface IApplicationInfoDto {
  version: string | undefined;
  features: { [key: string]: boolean; } | undefined;
  medNetUrl: string | undefined;
  stripePublishableKey: string | undefined;
}

export class PatientLoginInfoDto implements IPatientLoginInfoDto {
  name!: string | undefined;
  surname!: string | undefined;
  email!: string | undefined;
  id!: number;

  constructor(data?: IPatientLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.email = _data["email"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PatientLoginInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new PatientLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["email"] = this.email;
    data["id"] = this.id;
    return data;
  }
}

export interface IPatientLoginInfoDto {
  name: string | undefined;
  surname: string | undefined;
  email: string | undefined;
  id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
  application!: ApplicationInfoDto;
  patient!: PatientLoginInfoDto;

  constructor(data?: IGetCurrentLoginInformationsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
      this.patient = _data["patient"] ? PatientLoginInfoDto.fromJS(_data["patient"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetCurrentLoginInformationsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetCurrentLoginInformationsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["application"] = this.application ? this.application.toJSON() : <any>undefined;
    data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetCurrentLoginInformationsOutput {
  application: ApplicationInfoDto;
  patient: PatientLoginInfoDto;
}


export class ChangeLanguageDto implements IChangeLanguageDto {
  languageName!: string;

  constructor(data?: IChangeLanguageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.languageName = _data["languageName"];
    }
  }

  static fromJS(data: any): ChangeLanguageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeLanguageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["languageName"] = this.languageName;
    return data;
  }
}

export interface IChangeLanguageDto {
  languageName: string;
}

export class PatientLoginInput implements IPatientLoginInput {
  email!: string | undefined;
  password!: string;

  constructor(data?: IPatientLoginInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): PatientLoginInput {
    data = typeof data === 'object' ? data : {};
    let result = new PatientLoginInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["email"] = this.email;
    data["password"] = this.password;
    return data;
  }
}

export interface IPatientLoginInput {
  email: string | undefined;
  password: string;
}

export class RegisterInput implements IRegisterInput {
  firstname!: string;
  lastname!: string;
  countryId!: number;
  residenceCountryId!: number | undefined;
  dateOfBirth!: DateTime;
  ssn!: string | undefined;
  genderId!: number | undefined;
  email!: string;
  phoneNumber!: string;
  password!: string;
  address!: string | undefined;
  city!: string | undefined;
  zipCode!: string | undefined;
  passportNumber!: string | undefined;
  isUnder18YearsAllowed!: boolean;

  constructor(data?: IRegisterInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstname = _data["firstname"];
      this.lastname = _data["lastname"];
      this.countryId = _data["countryId"];
      this.residenceCountryId = _data["residenceCountryId"];
      this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
      this.ssn = _data["ssn"];
      this.genderId = _data["genderId"];
      this.email = _data["email"];
      this.phoneNumber = _data["phoneNumber"];
      this.password = _data["password"];
      this.address = _data["address"];
      this.city = _data["city"];
      this.zipCode = _data["zipCode"];
      this.passportNumber = _data["passportNumber"];
      this.isUnder18YearsAllowed = _data["isUnder18YearsAllowed"];
    }
  }

  static fromJS(data: any): RegisterInput {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["firstname"] = this.firstname;
    data["lastname"] = this.lastname;
    data["countryId"] = this.countryId;
    data["residenceCountryId"] = this.residenceCountryId;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
    data["ssn"] = this.ssn;
    data["genderId"] = this.genderId;
    data["email"] = this.email;
    data["phoneNumber"] = this.phoneNumber;
    data["password"] = this.password;
    data["address"] = this.address;
    data["city"] = this.city;
    data["zipCode"] = this.zipCode;
    data["passportNumber"] = this.passportNumber;
    data["isUnder18YearsAllowed"] = this.isUnder18YearsAllowed;
    return data;
  }
}

export interface IRegisterInput {
  firstname: string;
  lastname: string;
  countryId: number;
  residenceCountryId: number | undefined;
  dateOfBirth: DateTime;
  ssn: string | undefined;
  genderId: number | undefined;
  email: string;
  phoneNumber: string;
  password: string;
  address: string | undefined;
  city: string | undefined;
  zipCode: string | undefined;
  passportNumber: string | undefined;
  isUnder18YearsAllowed: boolean;
}

export class RegisterOutput implements IRegisterOutput {
  canLogin!: boolean;
  under18Years!: boolean;
  patientId!: number | undefined;

  constructor(data?: IRegisterOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canLogin = _data["canLogin"];
      this.under18Years = _data["under18Years"];
      this.patientId = _data["patientId"];
    }
  }

  static fromJS(data: any): RegisterOutput {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["canLogin"] = this.canLogin;
    data["under18Years"] = this.under18Years;
    data["patientId"] = this.patientId;
    return data;
  }
}

export interface IRegisterOutput {
  canLogin: boolean;
  under18Years: boolean;
  patientId: number | undefined;
}

@Injectable()
export class CountryServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "";
  }

  /**
   * @return Success
   */
  getAll(): Observable<ListResultDtoOfCountryOutputDto> {
    let url_ = this.baseUrl + "/api/services/app/Country/GetAll";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAll(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAll(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ListResultDtoOfCountryOutputDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ListResultDtoOfCountryOutputDto>;
    }));
  }

  protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfCountryOutputDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ListResultDtoOfCountryOutputDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getIpCountryOfRequest(): Observable<CountryIpResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Country/GetIpCountryOfRequest";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetIpCountryOfRequest(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetIpCountryOfRequest(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CountryIpResultDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CountryIpResultDto>;
    }));
  }

  protected processGetIpCountryOfRequest(response: HttpResponseBase): Observable<CountryIpResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CountryIpResultDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class SessionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "";
  }

  /**
   * @return Success
   */
  getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
    let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetCurrentLoginInformations(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCurrentLoginInformations(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
    }));
  }

  protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changeLanguage(body: ChangeLanguageDto | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/Session/ChangeLanguage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processChangeLanguage(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processChangeLanguage(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }
}

export class BankIdAuthAutoStartModel implements IBankIdAuthAutoStartModel {
  qrBase64Image!: string | undefined;
  orderRef!: string | undefined;
  autoStartToken!: string | undefined;

  constructor(data?: IBankIdAuthAutoStartModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.qrBase64Image = _data["qrBase64Image"];
      this.orderRef = _data["orderRef"];
      this.autoStartToken = _data["autoStartToken"];
    }
  }

  static fromJS(data: any): BankIdAuthAutoStartModel {
    data = typeof data === 'object' ? data : {};
    let result = new BankIdAuthAutoStartModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["qrBase64Image"] = this.qrBase64Image;
    data["orderRef"] = this.orderRef;
    data["autoStartToken"] = this.autoStartToken;
    return data;
  }
}

export interface IBankIdAuthAutoStartModel {
  qrBase64Image: string | undefined;
  orderRef: string | undefined;
  autoStartToken: string | undefined;
}

export class BankIdAuthenticateResultModel implements IBankIdAuthenticateResultModel {
  pendingType!: BankIdPendingType;
  pendingMessage!: string | undefined;
  qrBase64Image!: string | undefined;
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;
  patientId!: number | undefined;

  constructor(data?: IBankIdAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pendingType = _data["pendingType"];
      this.pendingMessage = _data["pendingMessage"];
      this.qrBase64Image = _data["qrBase64Image"];
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
      this.patientId = _data["patientId"];
    }
  }

  static fromJS(data: any): BankIdAuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new BankIdAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pendingType"] = this.pendingType;
    data["pendingMessage"] = this.pendingMessage;
    data["qrBase64Image"] = this.qrBase64Image;
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    data["patientId"] = this.patientId;
    return data;
  }
}

export interface IBankIdAuthenticateResultModel {
  pendingType: BankIdPendingType;
  pendingMessage: string | undefined;
  qrBase64Image: string | undefined;
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  patientId: number | undefined;
}

export enum BankIdPendingType {
  Pending = 1,
  Success = 2,
  Error = 3,
  AccountNotExist = 4,
  EmailNotConfirmed = 5,
}

export class PatientAuthenticateResultModel implements IPatientAuthenticateResultModel {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;
  patientId!: number | undefined;

  constructor(data?: IPatientAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
      this.patientId = _data["patientId"];
    }
  }

  static fromJS(data: any): PatientAuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new PatientAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    data["patientId"] = this.patientId;
    return data;
  }
}

export interface IPatientAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  patientId: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
  name!: string | undefined;
  clientId!: string | undefined;

  constructor(data?: IExternalLoginProviderInfoModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.clientId = _data["clientId"];
    }
  }

  static fromJS(data: any): ExternalLoginProviderInfoModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalLoginProviderInfoModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["clientId"] = this.clientId;
    return data;
  }
}

export interface IExternalLoginProviderInfoModel {
  name: string | undefined;
  clientId: string | undefined;
}

export class IsExternalAuthenticatedModel implements IIsExternalAuthenticatedModel {
  authProvider!: string;
  providerKey!: string;
  providerAccessCode!: string;

  constructor(data?: IIsExternalAuthenticatedModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authProvider = _data["authProvider"];
      this.providerKey = _data["providerKey"];
      this.providerAccessCode = _data["providerAccessCode"];
    }
  }

  static fromJS(data: any): IsExternalAuthenticatedModel {
    data = typeof data === 'object' ? data : {};
    let result = new IsExternalAuthenticatedModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["authProvider"] = this.authProvider;
    data["providerKey"] = this.providerKey;
    data["providerAccessCode"] = this.providerAccessCode;
    return data;
  }
}

export interface IIsExternalAuthenticatedModel {
  authProvider: string;
  providerKey: string;
  providerAccessCode: string;
}

export class SingleValueResultDtoOfBoolean implements ISingleValueResultDtoOfBoolean {
  value!: boolean;

  constructor(data?: ISingleValueResultDtoOfBoolean) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): SingleValueResultDtoOfBoolean {
    data = typeof data === 'object' ? data : {};
    let result = new SingleValueResultDtoOfBoolean();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value;
    return data;
  }
}

export interface ISingleValueResultDtoOfBoolean {
  value: boolean;
}

export class ExternalUserProfileInfoResultModel implements IExternalUserProfileInfoResultModel {
  id!: string | undefined;
  name!: string | undefined;
  emailAddress!: string | undefined;
  surname!: string | undefined;
  phoneNumber!: string | undefined;

  constructor(data?: IExternalUserProfileInfoResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.emailAddress = _data["emailAddress"];
      this.surname = _data["surname"];
      this.phoneNumber = _data["phoneNumber"];
    }
  }

  static fromJS(data: any): ExternalUserProfileInfoResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalUserProfileInfoResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["emailAddress"] = this.emailAddress;
    data["surname"] = this.surname;
    data["phoneNumber"] = this.phoneNumber;
    return data;
  }
}

export interface IExternalUserProfileInfoResultModel {
  id: string | undefined;
  name: string | undefined;
  emailAddress: string | undefined;
  surname: string | undefined;
  phoneNumber: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
  countryId!: number;
  dateOfBirth!: DateTime;
  ssn!: string | undefined;
  genderId!: number | undefined;
  phoneNumber!: string | undefined;
  authProvider!: string;
  providerKey!: string;
  providerAccessCode!: string;

  constructor(data?: IExternalAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.countryId = _data["countryId"];
      this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
      this.ssn = _data["ssn"];
      this.genderId = _data["genderId"];
      this.phoneNumber = _data["phoneNumber"];
      this.authProvider = _data["authProvider"];
      this.providerKey = _data["providerKey"];
      this.providerAccessCode = _data["providerAccessCode"];
    }
  }

  static fromJS(data: any): ExternalAuthenticateModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalAuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["countryId"] = this.countryId;
    data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
    data["ssn"] = this.ssn;
    data["genderId"] = this.genderId;
    data["phoneNumber"] = this.phoneNumber;
    data["authProvider"] = this.authProvider;
    data["providerKey"] = this.providerKey;
    data["providerAccessCode"] = this.providerAccessCode;
    return data;
  }
}

export interface IExternalAuthenticateModel {
  countryId: number;
  dateOfBirth: DateTime;
  ssn: string | undefined;
  genderId: number | undefined;
  phoneNumber: string | undefined;
  authProvider: string;
  providerKey: string;
  providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;
  waitingForActivation!: boolean;

  constructor(data?: IExternalAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"];
      this.encryptedAccessToken = _data["encryptedAccessToken"];
      this.expireInSeconds = _data["expireInSeconds"];
      this.waitingForActivation = _data["waitingForActivation"];
    }
  }

  static fromJS(data: any): ExternalAuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accessToken"] = this.accessToken;
    data["encryptedAccessToken"] = this.encryptedAccessToken;
    data["expireInSeconds"] = this.expireInSeconds;
    data["waitingForActivation"] = this.waitingForActivation;
    return data;
  }
}

export interface IExternalAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  waitingForActivation: boolean;
}

@Injectable()
export class PatientTokenAuthServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "";
  }

  /**
   * @return Success
   */
  bankIdLoginStart(): Observable<BankIdAuthAutoStartModel> {
    let url_ = this.baseUrl + "/api/PatientTokenAuth/BankIdLoginStart";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processBankIdLoginStart(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processBankIdLoginStart(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<BankIdAuthAutoStartModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<BankIdAuthAutoStartModel>;
    }));
  }

  protected processBankIdLoginStart(response: HttpResponseBase): Observable<BankIdAuthAutoStartModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = BankIdAuthAutoStartModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param orderRef (optional)
   * @return Success
   */
  bankIdCollectResponse(orderRef: string | undefined): Observable<BankIdAuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/PatientTokenAuth/BankIdCollectResponse?";
    if (orderRef === null)
      throw new Error("The parameter 'orderRef' cannot be null.");
    else if (orderRef !== undefined)
      url_ += "orderRef=" + encodeURIComponent("" + orderRef) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processBankIdCollectResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processBankIdCollectResponse(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<BankIdAuthenticateResultModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<BankIdAuthenticateResultModel>;
    }));
  }

  protected processBankIdCollectResponse(response: HttpResponseBase): Observable<BankIdAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = BankIdAuthenticateResultModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  authenticate(body: PatientLoginInput | undefined): Observable<PatientAuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/PatientTokenAuth/Authenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processAuthenticate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAuthenticate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<PatientAuthenticateResultModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<PatientAuthenticateResultModel>;
    }));
  }

  protected processAuthenticate(response: HttpResponseBase): Observable<PatientAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PatientAuthenticateResultModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
    let url_ = this.baseUrl + "/api/PatientTokenAuth/GetExternalAuthenticationProviders";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetExternalAuthenticationProviders(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetExternalAuthenticationProviders(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
    }));
  }

  protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  isExternalAuthenticated(body: IsExternalAuthenticatedModel | undefined): Observable<SingleValueResultDtoOfBoolean> {
    let url_ = this.baseUrl + "/api/PatientTokenAuth/IsExternalAuthenticated";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processIsExternalAuthenticated(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processIsExternalAuthenticated(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SingleValueResultDtoOfBoolean>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SingleValueResultDtoOfBoolean>;
    }));
  }

  protected processIsExternalAuthenticated(response: HttpResponseBase): Observable<SingleValueResultDtoOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SingleValueResultDtoOfBoolean.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getExternalUserProfileInfo(authProvider: string, providerAccessCode: string): Observable<ExternalUserProfileInfoResultModel> {
    let url_ = this.baseUrl + "/api/PatientTokenAuth/GetExternalUserProfileInfo?";
    if (authProvider === undefined || authProvider === null)
      throw new Error("The parameter 'authProvider' must be defined and cannot be null.");
    else
      url_ += "AuthProvider=" + encodeURIComponent("" + authProvider) + "&";
    if (providerAccessCode === undefined || providerAccessCode === null)
      throw new Error("The parameter 'providerAccessCode' must be defined and cannot be null.");
    else
      url_ += "ProviderAccessCode=" + encodeURIComponent("" + providerAccessCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetExternalUserProfileInfo(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetExternalUserProfileInfo(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ExternalUserProfileInfoResultModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ExternalUserProfileInfoResultModel>;
    }));
  }

  protected processGetExternalUserProfileInfo(response: HttpResponseBase): Observable<ExternalUserProfileInfoResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ExternalUserProfileInfoResultModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
    let url_ = this.baseUrl + "/api/PatientTokenAuth/ExternalAuthenticate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processExternalAuthenticate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processExternalAuthenticate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
    }));
  }

  protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }
}

export class SwedishPatientInfoFromCheckbizDto implements ISwedishPatientInfoFromCheckbizDto {
  name!: string | undefined;
  surname!: string | undefined;
  ssn!: string | undefined;
  birthDate!: DateTime | undefined;
  address!: string | undefined;
  zipCode!: string | undefined;
  city!: string | undefined;
  genderId!: number | undefined;

  constructor(data?: ISwedishPatientInfoFromCheckbizDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.surname = _data["surname"];
      this.ssn = _data["ssn"];
      this.birthDate = _data["birthDate"] ? DateTime.fromISO(_data["birthDate"].toString()) : <any>undefined;
      this.address = _data["address"];
      this.zipCode = _data["zipCode"];
      this.city = _data["city"];
      this.genderId = _data["genderId"];
    }
  }

  static fromJS(data: any): SwedishPatientInfoFromCheckbizDto {
    data = typeof data === 'object' ? data : {};
    let result = new SwedishPatientInfoFromCheckbizDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["surname"] = this.surname;
    data["ssn"] = this.ssn;
    data["birthDate"] = this.birthDate ? this.birthDate.toString() : <any>undefined;
    data["address"] = this.address;
    data["zipCode"] = this.zipCode;
    data["city"] = this.city;
    data["genderId"] = this.genderId;
    return data;
  }
}

export interface ISwedishPatientInfoFromCheckbizDto {
  name: string | undefined;
  surname: string | undefined;
  ssn: string | undefined;
  birthDate: DateTime | undefined;
  address: string | undefined;
  zipCode: string | undefined;
  city: string | undefined;
  genderId: number | undefined;
}

@Injectable()
export class PatientServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "";
  }

  /**
   * @param dateOfBirth (optional)
   * @param sSN (optional)
   * @return Success
   */
  getGetSwedishPatientFromSearch(dateOfBirth: DateTime | undefined, sSN: string | undefined): Observable<SwedishPatientInfoFromCheckbizDto> {
    let url_ = this.baseUrl + "/api/services/app/Patient/GetGetSwedishPatientFromSearch?";
    if (dateOfBirth === null)
      throw new Error("The parameter 'dateOfBirth' cannot be null.");
    else if (dateOfBirth !== undefined)
      url_ += "DateOfBirth=" + encodeURIComponent(dateOfBirth ? "" + dateOfBirth.toString() : "") + "&";
    if (sSN === null)
      throw new Error("The parameter 'sSN' cannot be null.");
    else if (sSN !== undefined)
      url_ += "SSN=" + encodeURIComponent("" + sSN) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "text/plain"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetGetSwedishPatientFromSearch(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetGetSwedishPatientFromSearch(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SwedishPatientInfoFromCheckbizDto>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SwedishPatientInfoFromCheckbizDto>;
    }));
  }

  protected processGetGetSwedishPatientFromSearch(response: HttpResponseBase): Observable<SwedishPatientInfoFromCheckbizDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SwedishPatientInfoFromCheckbizDto.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}


export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function _observableThrow(e: any) {
  return throwError(() => e);
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
